import React from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { monthYearLabel, fullDateLabel, monthlyTicks } from "../../lib/indicators";

const BUY = "oklch(0.58 0.13 145)";
const SELL = "oklch(0.55 0.21 25)";

export default function VolumeChart({ data }) {
  const series = data.map((d) => ({
    raw_date: d.quote_date,
    volume: Number(d.volume),
    isUp: Number(d.close) >= Number(d.open),
  }));
  const ticks = monthlyTicks(series);

  return (
    <div className="space-y-2">
      <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
        Volume diário
      </div>
      <div className="h-[220px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={series} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="oklch(0.92 0.004 286.32)" vertical={false} />
            <XAxis dataKey="raw_date" ticks={ticks} tickFormatter={monthYearLabel} interval={0} tick={{ fontSize: 10 }} stroke="oklch(0.552 0.016 285.938)" />
            <YAxis
              tick={{ fontSize: 10 }}
              stroke="oklch(0.552 0.016 285.938)"
              tickFormatter={(v) => {
                if (v >= 1e9) return `${(v / 1e9).toFixed(1)}B`;
                if (v >= 1e6) return `${(v / 1e6).toFixed(1)}M`;
                if (v >= 1e3) return `${(v / 1e3).toFixed(0)}K`;
                return v;
              }}
              width={50}
            />
            <Tooltip
              contentStyle={{
                background: "var(--popover)",
                border: "1px solid var(--border)",
                fontSize: 12,
              }}
              labelFormatter={fullDateLabel}
              formatter={(value) => [Number(value).toLocaleString("pt-BR"), "Volume"]}
            />
            <Bar dataKey="volume" isAnimationActive={false}>
              {series.map((s, idx) => (
                <Cell key={idx} fill={s.isUp ? BUY : SELL} opacity={0.65} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
